import { Link, useNavigate } from 'react-router-dom'

export function Footer() {
  const navigate = useNavigate()

  return (
    <footer className="border-t border-dash-border/70 bg-dash-bg">
      <div className="mx-auto flex max-w-7xl flex-col items-center justify-between gap-4 px-4 py-10 sm:flex-row sm:px-6 lg:px-8">
        <div className="flex items-center gap-2 text-sm font-bold text-dash-text">
          <span>SportsMeld</span>
          <span aria-hidden="true" className="inline-block h-1.5 w-1.5 rounded-full bg-dash-accent" />
        </div>

        <nav className="flex items-center gap-6 text-sm text-dash-secondary">
          <Link to="/docs" className="transition-colors hover:text-dash-text">
            Docs
          </Link>
          <button
            type="button"
            onClick={() => {
              navigate('/')
              setTimeout(
                () => document.getElementById('pricing')?.scrollIntoView({ behavior: 'smooth' }),
                50,
              )
            }}
            className="transition-colors hover:text-dash-text"
          >
            Pricing
          </button>
          <a href="/admin/login" className="transition-colors hover:text-dash-text">
            Admin
          </a>
        </nav>

        <p className="text-sm text-dash-muted">&copy; 2026 SportsMeld</p>
      </div>
    </footer>
  )
}
